import { screenSmMin } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { sidebarBaseWidth, zIndexFixed } from "../../styles";
export var Sidebar = styled.div.withConfig({
  displayName: "Sidebar",
  componentId: "sc-6utsg5-0"
})(["@media (min-width:", "){position:fixed;block-size:100%;top:0;inline-size:", ";left:0;z-index:", ";[dir='rtl'] &{left:unset;right:0;}}.docs-story &{position:relative;@media (min-width:", "){position:absolute;}}"], screenSmMin, function (props) {
  return props.sidebarWidth || sidebarBaseWidth;
}, zIndexFixed, screenSmMin);
export default Sidebar;